import React from 'react';
import Fade from 'react-reveal/Fade'
import styled from 'styled-components'
import background from '../videos/emanuel-background-video.mp4';

const TitleWrapper = styled.div`
    color: #000;
	background: rgba(255,255,255,0.4);
	padding: 1rem;
	width: 100%;
	
	@media (min-width: 768px) {
	    padding: 2rem 6rem;
	}
`;

const Title = styled.h1`
    position: relative;
	font-size: 52px;
	font-family: 'Montserrat', sans-serif;
	font-weight: 800;
	display: inline-block;
	color: #000;
`

const SubTitle = styled.h2`
	font-size: 28px;
	font-weight: 300;
    color: #000;
    margin-bottom: 2rem;
`;

const Lead = styled.div`
	font-size: 24px;
	margin-bottom: 3rem;
	font-style: italic;
`;

const Button = styled.button`
	background: transparent;
	border: 2px solid #000;
	padding: 14px 44px;
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
	outline: none;
	transition: all .2s;
	
	&:hover {
	    background: #000;
	    color: #fff;
	}
`;

const Video = styled.video`
    object-fit: cover;
	width: 100%;
    height: 100vh;
`

const Header = styled.header`
	position: fixed;
    top: 0;
	width: 100%;
    height: 100vh;
    z-index: -1;
    
    &, video {
	    width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
    }
    
    video {
        background: #fff;
        object-fit: cover;
        z-index: 1;
    }
`;

const Stuff = styled.div`
	position: absolute;
	width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    align-items: flex-end;
`;

const MyComponent = () => {
	return (
        <Header>
            <Video playsinline autoPlay muted loop>
                <source src={background} type="video/mp4" />
            </Video>
            <Stuff>
                <TitleWrapper>
                    <Fade duration={500} right cascade>
                        <Title>Emanuel Zevallos</Title>
                        <SubTitle>CECP, CBCP</SubTitle>
                        <Lead>One of the leading Emotion and Body Code practitioners in the world.</Lead>
                        <a href="https://compasshealing.as.me" target="_blank" rel="noreferrer"><Button>Book a Session</Button></a>
                    </Fade>
                </TitleWrapper>
            </Stuff>
        </Header>
	)
}

export default MyComponent;
